<template>
  <div>
    <general-table
      ref="countriesTable"
      :api-url="apiUrl"
      :add-component-name="addComponentName"
      :edit-component="editComponent"
      :delete-content="true"
      :block-content="false"
      :edit-content="true"
      :view-content="false"
      :add-type="addType"
      :columns="columns"
      :type="type"
      :filter-manufacture-white="true"
      :normal-search="false"
      :need-manufacture-template-download="true"
      :need-manufacture-template-import="true"
    >
      <template #cell(products)="data">
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li
            v-for="item in data.item.products"
            :key="item.id"
          >
            <span>{{ item }}</span>
          </li>
        </ul>
      </template>
      <template #cell(sub_products)="data">
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li
            v-for="item in data.item.sub_products"
            :key="item.id"
          >
            <span>{{ item }}</span>
          </li>
        </ul>
      </template>
      <template #cell(status)="data">
        <div class="d-flex align-items-center py-1 px-1">
          <span>
            {{ data.item.status == 1 ? '🟢' : '🔴' }}
          </span>
          <span :class="data.item.status == 1 ? 'text-success' : 'text-danger'">
            {{ resolveActiveUser(data.item.status) }}
          </span>
        </div>
      </template>
      <template #cell(activities_text)="data">
        <div
          v-b-tooltip.hover
          class="truncate-text px-1"
          :title="data.item.activities_text"
        >
          {{ data.item.activities_text }}
        </div>
      </template>
      <template #cell(address)="data">
        <div
          v-b-tooltip.hover
          class="truncate-text px-1"
          :title="data.item.address"
        >
          {{ data.item.address }}
        </div>
      </template>
    </general-table>
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  setup() {
    const resolveActiveUser = role => {
      if (role === '1') return 'Active'

      return 'Not Active'
    }
    return {
      resolveActiveUser,
    }
  },
  data() {
    return {
      APIURL: 'manufacture-white-lists',
      addType: 'Add Manufacture white',
      addComponentName: 'add-manufacture-white',
      editComponent: 'edit-manufacture-white',
      viewContent: true,
      type: 'page',
      filter: {},
      types: '',
      columns: [
        { key: 'status', label: 'Status' },
        { key: 'code', label: 'Code' },
        { key: 'name', label: 'Name' },
        { key: 'address', label: 'Address' },
        { key: 'activities_text', label: 'Activities' },
        { key: 'products', label: 'Product' },
        { key: 'sub_products', label: 'Sub Product' },
        { key: 'actions' },
      ],
    }
  },

  computed: {

    apiUrl() {
      let base = 'manufacture-white-lists?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      // console.log(base.slice(0, -1))
      return base.slice(0, -1)
    },
  },
  mounted() {
  },

  methods: {

    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },

  },
}
</script>

<style>
.truncate-text {
  max-width: 300px;    /* adjust width as you want */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
